import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react"; // icon burger & close

const Navbar = () => {
  const linkStyle =
    "text-white font-bold font-montserrat px-3 py-2 rounded hover:bg-[#153f85] hover:text-[#ffffff]";
  const activeStyle = "bg-[#153f85] text-[#0d3270]";
  const [isOpen, setIsOpen] = useState(false);

  // Smooth-scroll and close mobile menu when a nav link is clicked
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, hash: string) => {
    e.preventDefault();
    setIsOpen(false);
    const el = document.querySelector(hash);
    if (el) {
      (el as HTMLElement).scrollIntoView({ behavior: "smooth" });
    } else {
      // fallback: update hash
      window.location.hash = hash;
    }
  };

  return (
    <nav className="bg-[#0d3270] shadow-md fixed top-0 left-0 w-full z-50" role="navigation" aria-label="Main navigation">
      <div className="container mx-auto px-4 py-3 flex justify-between items-center">
        <Link to="/" className="text-white text-xl font-bold">Portfolio</Link>
        {/* Desktop Menu */}
        <div className="hidden md:flex space-x-6">
          <a href="#banner" className={linkStyle} onClick={(e) => handleNavClick(e, "#banner")}>Home</a>
          <a href="#skills" className={linkStyle} onClick={(e) => handleNavClick(e, "#skills")}>Skills</a>
          <a href="#experience" className={linkStyle} onClick={(e) => handleNavClick(e, "#experience")}>Experience</a>
          <a href="#service" className={linkStyle} onClick={(e) => handleNavClick(e, "#service")}>Service</a>
        </div>
        {/* Mobile Button */}
        <button
          className="md:hidden text-white focus:outline-none"
          aria-expanded={isOpen}
          aria-label={isOpen ? "Close menu" : "Open menu"}
          onClick={() => setIsOpen(!isOpen)}
        >
          {isOpen ? <X size={28} /> : <Menu size={28} />}
        </button>
      </div>
      {/* Mobile Menu */}
      {isOpen && (
        <div className="md:hidden bg-[#0d3270] px-4 pb-4 space-y-2 text-center">
          <a href="#banner" className={linkStyle} onClick={(e) => handleNavClick(e, "#banner")}>Home</a>
          <a href="#skills" className={linkStyle} onClick={(e) => handleNavClick(e, "#skills")}>Skills</a>
          <a href="#experience" className={linkStyle} onClick={(e) => handleNavClick(e, "#experience")}>Experience</a>
          <a href="#service" className={linkStyle} onClick={(e) => handleNavClick(e, "#service")}>Service</a>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
